<template>
  <div class="index">
    <div class="container" ref="container">
      <div class="swiper">
        <img src="../assets/images/首页banner.jpg" alt />
        <div class="bannertext">
          <p>{{$t('message.QualityBringsJoys')}}!</p>
          <p>Quality brings joys!</p>
        </div>
      </div>

      <div class="produce">
        <h2 class="title">{{$t('message.homeintroduce')}}</h2>
        <p class="info">{{$t('message.homeIntroduceText')}}</p>
        <div class="business width clearfix">
          <h2 class="title">{{$t('message.platform')}}</h2>
          <ul class="clearfix">
            <li>
              <div>
                <img src="../assets/images/来签.png" alt />
              </div>
              <h4>{{$t('message.toSign')}}</h4>
              <p>{{$t('message.toSignIntroduce')}}</p>
            </li>
            <li>
              <div>
                <img src="../assets/images/检验检测认证行业电子文件服务平台.png" alt />
              </div>
              <h4>{{$t('message.servicePlatform')}}</h4>
              <p>{{$t('message.servicePlatformIntroduce')}}</p>
            </li>
            <li>
              <div>
                <img src="../assets/images/质博士logo.png" alt />
              </div>
              <h4>{{$t('message.DrQuality')}}</h4>
              <p>{{$t('message.DrQualityIntroduce')}}</p>
            </li>
          </ul>
          <div class="collaborate">
            <h3>{{$t('message.cooperationPlatform')}}</h3>
            <p class="platform">{{$t('message.OnlineVerificationPlatformFor')}}</p>
            <div class="content">
              <img src="../assets/images/电子文件签名验证平台.jpg" alt />
              <p>{{$t('message.OnlineVerificationPlatformForIntroduce')}}</p>
            </div>
          </div>
          <div class="collaborate">
            <p class="QualityChainNetwork">{{$t('message.QualityChainNetwork')}}</p>
            <div class="details">
              <p>{{$t('message.QualityChainNetworkIntroduce')}}</p>
              <img src="../assets/images/质链网.png" alt />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  }
};
</script>
<style scoped>
.container {
  width: 100%;
}
.swiper {
  position: relative;
}
.swiper img {
  display: block;
  width: 100%;
  height: 530px;
}

.bannertext {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-weight: 700;
  font-family: Arial-BoldMT;
}
.bannertext p:first-child {
  font-size: 48px;
  color: #fff;
  margin-bottom: 30px;
}
.bannertext p:last-child {
  font-size: 26px;
  color: #fff;
}
.produce .title {
  margin-top: 80px;
  font-size: 36px;
  color: #ff6600;
  text-align: center;
  font-weight: 400;
}
.info {
  width: 608px;
  margin: 50px auto 0;
  line-height: 24px;
  text-align: left;
  font-size: 16px;
}
.business {
  margin-bottom: 55px;
}
.business ul {
  margin-top: 50px;
}
.business ul li {
  float: left;
  width: 380px;
  height: 513px;
  margin-right: 25px;
  box-shadow: 0px 3px 7px 0px rgba(0, 0, 0, 0.35);
  border-radius: 4px;
}
.business ul li:first-child {
  margin-left: 5px;
}
.business ul li:last-child {
  margin: 0;
}
.business ul li div {
  position: relative;
  height: 206px;
}
.business ul li div img {
  position: absolute;
  left: 50%;
  bottom: 44px;
  transform: translateX(-50%);
}
.business ul li:first-child img {
  width: 158px;
  height: 56px;
}
.business ul li:nth-child(2) img {
  width: 325px;
  height: 44px;
  bottom: 55px;
}
.business ul li:nth-child(3) img {
  width: 218px;
  height: 78px;
}
.business ul li h4 {
  font-size: 18px;
  font-weight: 400;
  padding: 30px 0;
}
.business ul li p {
  padding: 0 20px;
  text-align: left;
  color: #666666;
  line-height: 24px;
}

.collaborate h3 {
  font-size: 36px;
  color: #ff6600;
  margin-top: 130px;
  font-weight: 400;
}
.platform,
.QualityChainNetwork {
  margin: 60px 0;
  text-align: left;
  font-size: 24px;
}
.QualityChainNetwork {
  text-align: right;
}
.content,
.details {
  position: relative;
  text-align: left;
  height: 348px;
}

.content img {
  display: block;
  width: 600px;
  height: 340px;
}
.content p {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 0;
  width: 544px;
}

.details img {
  position: absolute;
  width: 748px;
  height: 348px;
  top: 50%;
  right: -110px;
  transform: translateY(-50%);
}
.details p {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 0;
  width: 544px;
}
/* .pointer {
  position: absolute;
  bottom: 20px;
  left: 944px;
}
.pointer li {
  float: left;
  width: 8px;
  height: 8px;
  background-color: #fff;
  opacity: 0.6;
  margin-right: 12px;
  border-radius: 50%;
  cursor: pointer;
}
.pointer .current {
  width: 46px;
  border-radius: 4px;
  background-color: #767677;
} */
</style>



// WEBPACK FOOTER //
// src/components/Index.vue